import React from "react"
import { ClienteInfo } from "../cliente-info";
import { ContratoData } from "./contrato";

export const ListaProdutos = () => {
  return (
    <div className="flex max-h-full flex-col items-center px-2">
      <div className="my-2 w-full px-4">
        <ClienteInfo />
      </div>

      <div className="my-2 w-full px-4">
        <ContratoData />
      </div>
    </div>
  )
}